import React from 'react';
import { SectionHeading } from '../SectionHeading';
const panels = [{
  heading: 'High-positive cutting geometry',
  copy: 'A sharp, open cutting presentation helps the tool shear soft or difficult-to-control material instead of pushing through it.',
  image: 'https://cdn.magicpatterns.com/uploads/pbZ2ziF66snTjfxySoMu69/rp-principle-high-positive-geometry-1200x500.png',
  imageAlt: 'Macro view of a high-positive-rake CNC insert shearing aluminum with a controlled ribbon chip.'
}, {
  heading: 'Polished insert faces',
  copy: 'Published MG12 configurations use polished inserts intended to reduce material adhesion at the cutting edge.',
  image: 'https://cdn.magicpatterns.com/uploads/kF88qY6UcwMWS746VqmH1h/rp-principle-polished-insert-face-1200x500.png',
  imageAlt: 'Macro view of a polished carbide insert face mounted on a CNC lathe holder.'
}, {
  heading: 'A modular product system',
  copy: 'Choose the holder size, insert style and replacement components that match the machine setup and work material.',
  image: 'https://cdn.magicpatterns.com/uploads/5um8iiPLfmBESrpMPRjZcq/rp-principle-modular-system-1200x500.png',
  imageAlt: 'Close-up modular CNC tooling set with holder, insert, screw and driver.'
}];
export function SystemSection() {
  return <section aria-labelledby="system-heading" className="w-full bg-white" data-id="element-359" data-mp="3sfnci3v0fch1">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-10 lg:py-24" data-id="element-360" data-mp="3epbhnx71izm7">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:gap-20" data-id="element-361" data-mp="3jhbj5u2re0kw">
          <SectionHeading id="system-heading" eyebrow="THE CUTTING SYSTEM" heading="A high-positive-rake system built to manage the cut" data-id="element-362" data-mp="34sfg6bfk7dr5" />
          <p className="rp-measure self-end text-[15.5px] leading-[1.7] text-graphite/80" data-id="element-363" data-mp="2vrhaloph2y6g">
            Shear Geometry pairs a rigid external holder with highly polished
            APGX inserts. The published guidance describes geometry
            intended to limit built-up edge and direct chips away from the
            turret in 6061-T6 aluminum, copper and soft aluminum alloys, with
            separate DR80 configurations for titanium.
          </p>
        </div>

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-364" data-mp="wi7ob0lwvbsk">
          {panels.map((panel, i) => <li key={panel.heading} className="flex" data-id="element-365" data-mp="rjcwxa9voewu" data-mpi={i}>
              <article className="flex w-full flex-col border border-rule bg-white" data-id="element-366" data-mp="1p7n03sleh8pj">
                <div className="relative h-[160px] w-full overflow-hidden border-b border-rule lg:h-[170px]" data-id="element-367" data-mp="1kawih0ty6520">
                  <p className="absolute bottom-2.5 left-2.5 z-10 border border-white/25 bg-navy/80 px-2 py-1 font-mono text-[9px] leading-none tracking-label text-aluminum" data-id="element-368" data-mp="1f9gvv4c4fqhi">
                    ILLUSTRATION
                  </p>
                  <img src={panel.image} alt={panel.imageAlt} width={1200} height={500} loading="lazy" decoding="async" className="h-full w-full object-cover object-center" data-id="element-369" data-mp="3tijorlncoc2" />
                </div>
                <div className="flex flex-1 flex-col p-6 lg:p-7" data-id="element-370" data-mp="2kh0b5nnjax2y">
                  <span className="font-mono text-[10px] tracking-label text-copper" data-id="element-371" data-mp="2p8rupe89w2jl">
                    {`0${i + 1}`}
                  </span>
                  <h3 className="mt-4 font-display text-[19px] font-medium leading-snug text-navy" data-id="element-372" data-mp="2u732zkix64zp">
                    {panel.heading}
                  </h3>
                  <p className="mt-3 text-[14.5px] leading-[1.65] text-graphite/80" data-id="element-373" data-mp="338stmo4z8zwf">
                    {panel.copy}
                  </p>
                </div>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}